// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","bar":"_1tWN","texture":"_1fX9","inner":"_1a9Z","title":"_9jWA","content":"QJPO"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Layout/BarPage/BarPage.scss
// module id = vJ+k
// module chunks = 0